import { Component } from '@angular/core';
import { Platform } from '@ionic/angular';

@Component({
  selector: 'app-root',
  templateUrl: 'app.component.html',
  styleUrls: ['app.component.scss']
})
export class AppComponent {
  constructor(
    private platform: Platform,
  ) {
    this.initializeApp();
  }

  initializeApp() {
    this.platform.ready().then(() => {
      // if (this.platform.is('android') == true) {alert('ios')}
      //  console.log(this.platform);
      //  console.log(this.platform.is('android'));
      //  console.log(this.platform.is('desktop'));
      //  console.log(this.platform.is('capacitor'));
    });
  }
}
